import styled from '@emotion/styled/macro';
import { Variables } from '@enter/core';
import Icon from '@mdi/react';

export const Container = styled.section`
    width: 100%;
    display: flex;
    align-items: flex-start;
`;

export const Step = styled.div<{ clickable: boolean }>`
    flex: 1;
    position: relative;
    cursor: ${({ clickable }): string => (clickable ? 'pointer' : 'default')};
`;

export const Header = styled.div`
    display: flex;
    align-items: center;
    height: 24px;
`;

export const CheckIcon = styled(Icon)``;

interface IStepState {
    isCompleted: boolean;
    isActive: boolean;
    isLast: boolean;
}

export const IconWrapper = styled.div<IStepState>`
    position: relative;
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    width: ${(props: IStepState): string => (props.isCompleted ? '24px' : '18px')};
    height: ${(props: IStepState): string => (props.isCompleted ? '24px' : '18px')};
    background-color: ${(props: IStepState): string =>
        props.isCompleted || props.isActive ? Variables.Colors.b300 : Variables.Colors.n15};
    border-radius: 50%;
    ${CheckIcon} {
        path {
            fill: ${Variables.Colors.white};
        }
    }
`;

export const LastIcon = styled.div`
    width: 8px;
    height: 8px;
    background-color: ${Variables.Colors.white};
    border-radius: 50%;
`;

export const Line = styled.div<{ isActive: boolean }>`
    height: 4px;
    left: 0;
    background-color: ${(props): string => (props.isActive ? Variables.Colors.b300 : Variables.Colors.n15)};
    position: absolute;
    width: 100%;
`;

export const DescriptionWrapper = styled.div<IStepState>`
    color: ${(props): string =>
        props.isActive ? Variables.Colors.n100 : props.isCompleted ? Variables.Colors.n50 : Variables.Colors.n15};
`;

export const StepIndex = styled.div`
    margin-top: 20px;
    font-size: 15px;
    font-weight: 600;
    text-transform: uppercase;
`;

export const Description = styled.div`
    margin-top: 4px;
    font-size: 16px;
`;
